import FileField from './component';
import { FileFieldProps } from './types';

export type { FileFieldProps };
export default FileField;
